export const LANDING_TYPES = {
  MERCHANT: 'MERCHANT',
  MODEL: 'MODEL',
}
